// Real captured execution config for a Decisions simulation run, shown in the
// Decision Canvas "Execution Config Details" modal to link the canvas to an
// actual run. Static for now: the execution service is not exposed through the
// UX gateway (needs a BFF proxy route); swap to a live fetch by run_id later.
// TODO(engineer): this is a real tenant run's data (run_id, solution_id, workflow_name,
// nested run_ids) hardcoded directly into feature code and rendered in production UI.
// Follow-up: add a BFF proxy route for the solutions service and fetch this by solution id
export const EXECUTION_CONFIG_SAMPLE = {
  run_id: '67685cbe-ff70-4da4-95cd-0351a6d6aee3',
  solution_id: 'run-20260507-0330',
  workflow_name: 'wf-67685cbe-ff70-4da4-95cd-0351a6d6aee3',
  phase: 'Succeeded',
  message: null,
  started_at: '2026-06-24T19:50:19+00:00',
  finished_at: '2026-06-24T22:02:56.774275+00:00',
  created_at: '2026-06-24T19:50:19.106631+00:00',
  solution_content: {
    image_uri:
      '251964342139.dkr.ecr.us-west-2.amazonaws.com/ksai-inventory-simulator-docker:c153a53d08111cadc0e80658b8da6e836179cd51',
    resource_config: {
      cpu: '64',
      memory: '256Gi',
      workflow_dshm_gib: 16,
    },
    job_name: 'prod_inv_simulator-nile',
    scenario_run_id: 'z100-config-4k-sku-20260624',
    storage: {
      bucket: 's3://ksai-inventory-simulator-data-251964342139/nile/',
    },
    global_experiment_parameters: {
      TIME_PERIOD: 'weekly',
      SITE_LIST: ['North America'],
      DEDUCT_INV_BY: 'dmd',
      SIM_START: '2025-02-03',
      SIM_END: '2025-05-05',
      APPLY_INITIAL_INV_0: false,
      SITE_LEVEL: 'North America',
    },
    global_experiment_inputs: {
      site_sku_period: {
        cdp: {
          database: 'nile_gold',
          table: 'fact_inventory_site_product_period_metrics',
          partitions: {
            snapshot_id: '20250916',
            frequency: 'W-SUN',
            site: 'North America',
          },
        },
      },
      site_sku: {
        cdp: {
          database: 'nile_gold',
          table: 'dim_site_product_enriched',
          partitions: {
            snapshot_id: '20250916',
            site: 'North America',
          },
        },
      },
      sku: {
        cdp: {
          database: 'nile_silver',
          table: 'dim_products',
          partitions: {
            snapshot_id: '20250916',
          },
        },
      },
      site_sku_sample:
        's3://ksai-inventory-simulator-data-251964342139/nile/inputs/df_site_sku_sample_na_final_fcst_all14_x_full14.csv',
      forecast_actuals: {
        fidb: {
          bundle_name: 'fact_orders_weekly_nile_D_20250619_quantity_order_date_filtered_v1.0',
        },
      },
      forecast_demand: {
        mds: {
          file_id_prefix: 'aggregate/product_id_ship_to_region/forecast.parquet',
          runs: [
            {
              fct: '2025-02-02',
              run_id: 'da68d3ef-b2ee-465f-98a3-c2c5af6fe338',
            },
            {
              fct: '2025-02-09',
              run_id: '295a9e39-641e-44f8-b329-88d50ac2c778',
            },
            {
              fct: '2025-02-16',
              run_id: 'a0f5fbc0-dde2-4ecb-9dd7-efbea4b5fe9e',
            },
            {
              fct: '2025-02-23',
              run_id: 'a7587ec9-036a-4c50-88d5-d96d5d845770',
            },
            {
              fct: '2025-03-02',
              run_id: '3a3db72e-cff0-406a-bad5-01fbb5eb7c89',
            },
            {
              fct: '2025-03-09',
              run_id: 'fb6b2dd0-aa58-4fb6-9bc3-b9bef85d71f6',
            },
            {
              fct: '2025-03-16',
              run_id: '793ab2e5-5654-42b7-80fc-02ea25a0fc0e',
            },
            {
              fct: '2025-03-23',
              run_id: 'd2760c1b-c91f-40b9-a55e-8749323dc770',
            },
            {
              fct: '2025-03-30',
              run_id: '274593dd-bf74-40fa-9754-78616870f71d',
            },
            {
              fct: '2025-04-06',
              run_id: '69a27cb2-5be0-4cf1-9237-0b5ee8002343',
            },
            {
              fct: '2025-04-13',
              run_id: 'ebd0fa38-3d70-4929-9507-f7009b19d46e',
            },
            {
              fct: '2025-04-20',
              run_id: 'b4bea8cb-5f94-48c9-8662-319b01218215',
            },
            {
              fct: '2025-04-27',
              run_id: 'a14f9d5f-f0e9-47c1-9969-b5d0f71a75ca',
            },
            {
              fct: '2025-05-04',
              run_id: '5cb1ebd2-a9f8-4582-b25d-4557c41d60ac',
            },
          ],
        },
      },
    },
    actions: [
      {
        _comment: '===== LT sensitivity (RC , LT ) =====',
        simulate: [
          {
            _comment: 'RC=4, LT 0 | BFG, P50, ALPHA_SL, TRNQ_TIP, HIST_CR (Baseline)',
            experiment: 'Baseline Policy',
            experiment_overrides: {
              deduct_proj_inv_by: 'USE_P50_FCST',
              use_which_sl: 'USE_ALPHA_CYCLE_SL',
              use_which_tip: 'USE_TRNQ_TIP',
              use_which_cr: 'USE_HIST_CR',
              is_respect_historical_review_week: false,
              order_overage_threshold: 0,
              hold_cost_perc_period: 0.00480769230769231,
              review_cycle: 4,
              lead_time_delta: 0,
            },
            outputs: {
              run_id: 'rc_4-ltdelta_0-forecast_BFG-col_P50-sltype_ALPHA_CYCLE-tip_TRNQ-cr_HIST',
            },
          },
          {
            _comment: 'RC=4, LT 0 | ETS, MEAN, ALPHA_SL, SSCS_TIP, HIST_CR (Incumbent)',
            experiment: 'Incumbent',
            experiment_overrides: {
              deduct_proj_inv_by: 'USE_POINT_FCST',
              use_which_sl: 'USE_ALPHA_CYCLE_SL',
              use_which_tip: 'USE_SSCS_TIP',
              use_which_cr: 'USE_HIST_CR',
              is_respect_historical_review_week: false,
              order_overage_threshold: 0,
              hold_cost_perc_period: 0.00480769230769231,
              review_cycle: 4,
              lead_time_delta: 0,
            },
            inputs: {
              forecast_demand: {
                mds: {
                  file_id_prefix: 'aggregate/product_id_ship_to_region/',
                  runs: [
                    {
                      fct: '2025-02-02',
                      run_id: 'd6fc8a36-9497-4f45-84f1-18233581c330',
                    },
                    {
                      fct: '2025-02-09',
                      run_id: '5f153146-a46c-4f96-add8-24384b0b2f21',
                    },
                    {
                      fct: '2025-02-16',
                      run_id: 'ca4734be-836a-4f9d-af47-fbe0a92eb76d',
                    },
                    {
                      fct: '2025-02-23',
                      run_id: 'c2a8b12c-6318-412b-a57e-1724d6c07d21',
                    },
                    {
                      fct: '2025-03-02',
                      run_id: 'b9cfea73-7e03-43a5-b00b-060a35ab685a',
                    },
                    {
                      fct: '2025-03-09',
                      run_id: '1c96f30c-0bf2-4981-a210-0bc053a7c135',
                    },
                    {
                      fct: '2025-03-16',
                      run_id: 'bc5717c5-0692-4796-8f4d-c84f56bf08dd',
                    },
                    {
                      fct: '2025-03-23',
                      run_id: 'c712695a-6862-4271-93ab-cc9f6ebf81ee',
                    },
                    {
                      fct: '2025-03-30',
                      run_id: 'b82dc448-77b2-45d2-976c-c64d0b8ee1b6',
                    },
                    {
                      fct: '2025-04-06',
                      run_id: '10c00730-7044-4c99-b4a6-43c014240b19',
                    },
                    {
                      fct: '2025-04-13',
                      run_id: '4591f262-51ed-4240-be7e-1cd2144cc7f4',
                    },
                    {
                      fct: '2025-04-20',
                      run_id: 'f5128ba1-d7ba-47ac-a20e-3b9d27bfc595',
                    },
                    {
                      fct: '2025-04-27',
                      run_id: 'af6f3669-6af1-40f9-8356-4ff22b5071ea',
                    },
                    {
                      fct: '2025-05-04',
                      run_id: '505996f5-34c8-457b-8472-e7c64bba3eac',
                    },
                  ],
                },
              },
            },
            outputs: {
              run_id: 'rc_4-ltdelta_0-forecast_ETS-col_POINT-sltype_ALPHA_CYCLE-tip_SSCS-cr_HIST',
            },
          },
          {
            _comment: 'RC=4, LT 0 | BFG, P50, ALPHA_SL, TRNQ_TIP, OPT_CR (Keystone Enhanced)',
            experiment: 'Keystone Enhanced',
            experiment_overrides: {
              deduct_proj_inv_by: 'USE_P50_FCST',
              use_which_sl: 'USE_ALPHA_CYCLE_SL',
              use_which_tip: 'USE_TRNQ_TIP',
              use_which_cr: 'USE_OPT_CR',
              is_respect_historical_review_week: false,
              order_overage_threshold: 0,
              hold_cost_perc_period: 0.00480769230769231,
              review_cycle: 4,
              lead_time_delta: 0,
            },
            outputs: {
              run_id: 'rc_4-ltdelta_0-forecast_BFG-col_P50-sltype_ALPHA_CYCLE-tip_TRNQ-cr_OPT',
            },
          },
          {
            _comment: 'RC=2, LT -2 | BFG, P50, ALPHA_SL, TRNQ_TIP, OPT_CR(Keystone Optimized)',
            experiment: 'Keystone Optimized',
            experiment_overrides: {
              deduct_proj_inv_by: 'USE_P50_FCST',
              use_which_sl: 'USE_ALPHA_CYCLE_SL',
              use_which_tip: 'USE_TRNQ_TIP',
              use_which_cr: 'USE_OPT_CR',
              is_respect_historical_review_week: false,
              order_overage_threshold: 0,
              hold_cost_perc_period: 0.00480769230769231,
              review_cycle: 2,
              lead_time_delta: -2,
            },
            outputs: {
              run_id: 'rc_2-ltdelta_-2-forecast_BFG-col_P50-sltype_ALPHA_CYCLE-tip_TRNQ-cr_OPT',
            },
          },
        ],
      },
      {
        validate: {
          parameters: {
            skip_cross: false,
            fail_on_error: false,
          },
        },
      },
      {
        evaluate: {
          parameters: {
            time_period: 'weekly',
            join_type: 'inner',
            top_n: 10,
          },
          inputs: {
            runs: [
              {
                run_id: 'rc_4-ltdelta_0-forecast_ETS-col_POINT-sltype_ALPHA_CYCLE-tip_SSCS-cr_HIST',
              },
              {
                run_id: 'rc_4-ltdelta_0-forecast_BFG-col_P50-sltype_ALPHA_CYCLE-tip_TRNQ-cr_HIST',
              },
              {
                run_id: 'rc_4-ltdelta_0-forecast_BFG-col_P50-sltype_ALPHA_CYCLE-tip_TRNQ-cr_OPT',
              },
              {
                run_id: 'rc_2-ltdelta_-2-forecast_BFG-col_P50-sltype_ALPHA_CYCLE-tip_TRNQ-cr_OPT',
              },
            ],
          },
        },
      },
    ],
  },
} as const;
